import React from "react";

import ContentWrapper from "./util/ContentWrapper";
import MoveBoxWrapper from "./edit/wrapper/MoveBoxWrapper";
import MoveTools from "./edit/moveTools/MoveTools";

function EditContent({
    toggleList,
    drawerList,
    changeItemIndex,
    callConfirmChangeDrawerListSort,
    changeEditDrawerListToOriginalDrawerList,
}) {
    return (
        <ContentWrapper>
            <MoveBoxWrapper
                toggleList={toggleList}
                callConfirmChangeDrawerListSort={callConfirmChangeDrawerListSort}
                changeEditDrawerListToOriginalDrawerList={changeEditDrawerListToOriginalDrawerList}
            >
                <MoveTools drawerList={drawerList} changeItemIndex={changeItemIndex} />
            </MoveBoxWrapper>
        </ContentWrapper>
    );
}

export default EditContent;
